import { Button, Drawer, NonIdealState, Tooltip } from '@blueprintjs/core';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../utils/context/app.context';
import { toast } from 'react-toastify';
import { AuthContext } from '../../utils/context/auth.context.ts';
import TableApp from '../../utils/components/table.component.js';
import processService from '../../services/process.service.js';

export default function SalesDetails(props) {
    const { date, text, icon, item } = props;
    const [isOpen, setOpen] = useState(false)
    const [items, setItems] = useState([])
    const [isLoading, setLoading] = useState(false)
    const { t } = useTranslation();
    const appContext = useContext(AppContext)
    const authContext = useContext(AuthContext)

    function searchSales(month) {
        if (authContext.verify({ pathname: "/prs" }, "GET")) {
            setLoading(true)
            setItems([])
            processService.search_sales(month)
                .then(res => {
                    setItems(res.data);
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t);

                })
                .finally(() => setLoading(false))
        } else {
            toast.warning(t('auth.nopermit'))
        }
    }

    useEffect(() => {
        searchSales(date)
    }, []);

    const columns = [
        {
            name: t("prs.table.sale_codigo"),
            text: row => row.codigo,
        },
        {
            name: t("prs.table.sale_desc"),
            text: row => row.nombre,
            width: "50%",
        },
           {
            name: t("prs.table.sale_value"),
            text: row => appContext.formatCurrency(row.monto),
        },

    ];

    const body = () => (<div className='m-5'>
        <TableApp
            data={items}
            columns={columns}
            loading={isLoading}
            title={t("prs.saleDetails_title").replace("%VAR%", date)}
            id="salesDetails"
            noPag
        />
    </div>)

    const LOADING = <div class="text-center mt-5 pt-5">
        <div class="spinner-border" role="status">
        </div>
    </div>

    const NO_DATA = <div className='p-5'>
        <NonIdealState
            icon={'help'}
            iconSize={44}
            title={t('table.nodata')}
            description={t('table.nodatast')}
            layout={'vertical'}
        />
    </div>

    return (<>
        <Tooltip content={t('actions.see_more')} placement="top">
            {text ? <div onClick={() => {
                setOpen(true);
            }}><span className={`bp5-icon bp5-icon-${icon || "eye-open"} text-primary`} />{` ${text}`}</div> :
                <Button icon={icon || "eye-open"} intent='primary' onClick={() => {
                    setOpen(true);
                }} />
            }
        </Tooltip>
        <Drawer
            className={'rockai-drawer'}
            icon="info-sign"
            onClose={() => setOpen(false)}
            isOpen={isOpen}
            title={t("pro.more.title").replace("%VAR%", item?.codigo || '')}
            size={"default"}

        >
            <div className='app-drawer'>
                {isLoading ? LOADING : item ? body() : NO_DATA}
            </div>
        </Drawer>
    </>
    );
}
